import React, { useState, MouseEvent, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  MenuItem,
  Container,
  Avatar,
  Button,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
  SvgIcon,
  Switch,
  FormControlLabel,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Logoapp from '../../../assets/img/logoapp.png';
import usericon from '../../../assets/img/user-img.png';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.scss';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { authen } from '../../firebase/firebase';
import ConfirmModal from '../ConfirmModal';
import { useDispatch, useSelector } from 'react-redux';
import { setUserProfile } from 'shared/store/src/lib/actions/userprofile';
import { formatName } from 'shared/functions/home';

import { ReactComponent as Hamburger } from '../../../assets/img/hamburger.svg';
import CustomDeleteModal from '../CustomDeleteModal';
import deleteAccountApi from 'shared/Utils/DeleteUserApi/Api';
import CustomNoResponseModal from '../CustomNoResponseModal';
import RemoteErrorLog from '../../Utils/api';
import { setFilter } from 'shared/store/src/lib/actions/filter';
import { setBadge } from 'shared/store/src/lib/actions/badges';
import { setLevelImage } from 'shared/store/src/lib/actions/levelsImage';
import { setAvatar } from 'shared/store/src/lib/actions/avatars';
import { setProduct } from 'shared/store/src/lib/actions/products';
import { isuserPremium } from '../../Utils/firebase-services';
import { environment } from 'apps/spellingheroweb/src/environments/environment';
import { ArrowForward } from '@mui/icons-material';

const GlowingButton = styled(Button)<{ active?: boolean; component?: any; to?: string }>(({ theme, active }) => ({
  position: 'relative',
  padding: '8px 20px',
  margin: '0 8px',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  overflow: 'hidden',
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '16px',
  color: active ? '#2A9235' : '#5E5E5E',
  background: active 
    ? 'linear-gradient(135deg, rgba(42, 146, 53, 0.1) 0%, rgba(76, 175, 80, 0.1) 100%)'
    : 'transparent',
  border: `1px solid ${active ? 'rgba(42, 146, 53, 0.2)' : 'transparent'}`,
  borderRadius: '25px',
  
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(42, 146, 53, 0.1), transparent)',
    transition: 'left 0.5s ease',
    zIndex: 1,
  },
  
  '&:hover': {
    transform: 'translateY(-2px) scale(1.02)',
    color: '#2A9235',
    background: 'linear-gradient(135deg, rgba(42, 146, 53, 0.1) 0%, rgba(76, 175, 80, 0.1) 100%)',
    border: '1px solid rgba(42, 146, 53, 0.3)',
    boxShadow: '0 8px 25px rgba(42, 146, 53, 0.2)',
    '&::before': {
      left: '100%',
    },
  },
  
  '&:active': {
    transform: 'translateY(0) scale(0.98)',
  },
  
  '& .MuiButton-root': {
    position: 'relative',
    zIndex: 2,
  },
}));

const PremiumButton = styled(Button)<{ component?: any; to?: string; variant?: string; size?: string; endIcon?: any }>({
  position: 'relative',
  // background: 'linear-gradient(135deg, #8B5CF6 0%, #A855F7 100%)',
  // color: '#FFFFFF',
  background: 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)',
  color: '#1F2937',
  borderRadius: '50px',
  textTransform: 'none',
  fontWeight: 600,
  overflow: 'hidden',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, transparent 50%, rgba(255, 255, 255, 0.2) 100%)',
    transform: 'translateX(-100%)',
    transition: 'transform 0.6s ease',
  },
  
  '&:hover': {
    transform: 'translateY(-3px) scale(1.02)',
    '&::before': {
      transform: 'translateX(100%)',
    },
  },
  
  '&:active': {
    transform: 'translateY(-1px) scale(0.98)',
  },
});

const AnimatedAvatar = styled(Avatar)({
  position: 'relative',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  cursor: 'pointer',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: -3,
    left: -3,
    right: -3,
    bottom: -3,
    borderRadius: '50%',
    background: 'linear-gradient(45deg, #2A9235, #4CAF50, #2A9235)',
    opacity: 0,
    transition: 'opacity 0.3s ease',
    zIndex: -1,
  },
  '&:hover': {
    transform: 'scale(1.1) rotate(5deg)',
    '&::before': {
      opacity: 1,
    },
  },
});

export default function Navbar({ currentPage }: any) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [authMenuAnchor, setAuthMenuAnchor] = useState<null | HTMLElement>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [
    isSubscriptionDeleteModalVisible,
    setIsSubscriptionDeleteModalVisible,
  ] = useState(false);

  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState<any>();
  const [userData, setUserData] = useState<any>();
  const [isCookiePolicyModalVisible, setIsCookiePolicyModalVisible] =
    useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState<string>('');
  const [isQuestionModalVisible, setIsQuestionModalVisible] = useState(false);
  const profile = useSelector((state: any) => state.userprofile);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleClose = () => {
    setOpen(false);
  };

  const [isSoundEnabled, setIsSoundEnabled] = useState(true);

  useEffect(() => {
    const savedSoundPreference = localStorage.getItem('GlobalSoundsControl');
    if (savedSoundPreference === null) {
      localStorage.setItem('GlobalSoundsControl', 'ON');
      setIsSoundEnabled(true);
    } else {
      setIsSoundEnabled(savedSoundPreference !== 'OFF');
    }
  }, []);

  const handleLogoutClick = () => {
    setOpen(true);
  };
  const handleDeleteClick = () => {
    setIsModalVisible(true);
  };
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(authen, async (currentUser) => {
      setUser(currentUser); // Update the user state
      if (currentUser) {
        const idTokenResult = await currentUser.getIdTokenResult();
      } else {
        localStorage.removeItem('userData');
      }
    });
    // Clean up the listener when the component unmounts
    return () => unsubscribe();
  }, [dispatch]);
  useEffect(() => {
    if (localStorage.getItem('userData')) {
      const data = localStorage.getItem('userData') ?? '{}';
      setUserData(JSON.parse(data));
    }
  }, [localStorage.getItem('userData')]);
  useEffect(() => {
    if (currentPage !== 'result') {
      localStorage.removeItem('resultState');
    } else if (currentPage !== 'quiz') {
      localStorage.removeItem('quizState');
    } else if (currentPage !== 'quizResult') {
      localStorage.removeItem('quizResultState');
    }
  }, [currentPage]);
  const signOutUser = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    const questionInfo = {
      uid: '',
      mode: '',
      level: '',
      filter_type: '',
      filter_value: '',
      include_incorrect: '',
    };
    if (user !== null) {
      localStorage.removeItem('userData');
      localStorage.removeItem('pronunciationMode');
      localStorage.removeItem('userSpellingPreference');
      localStorage.removeItem('isLoggedInViaClever');
      localStorage.removeItem('GlobalSoundsControl');
      await authen.signOut();
      setUserData({});
      handleClose();

      await dispatch(setFilter(questionInfo));
      await dispatch(setUserProfile(''));
      await dispatch(setBadge(null));
      await dispatch(setLevelImage([]));
      await dispatch(setAvatar([]));
      await dispatch(setProduct([]));

      navigate('/login');
    } else {
      localStorage.removeItem('userData');
      await dispatch(setFilter(questionInfo));
      await dispatch(setUserProfile(''));
      await dispatch(setBadge(null));
      await dispatch(setLevelImage([]));
      await dispatch(setAvatar([]));
      await dispatch(setProduct([]));

      setUserData({});
      handleClose();
      navigate('/login');
    }
  };

  const handleDeleteAccount = async () => {
    let value = await isuserPremium();
    if (value) {
      setIsModalVisible(false);
      setIsSubscriptionDeleteModalVisible(true);
    } else {
      deleteAccount();
    }
  };
  const deleteAccount = async () => {
    const user = authen.currentUser;
    const decodedToken: any = await authen?.currentUser?.getIdTokenResult();

    if (user) {
      try {
        const userInfo = {
          uid: user?.uid,
          revCatSubscription:
            decodedToken?.claims?.revenueCatEntitlements &&
              decodedToken?.claims?.revenueCatEntitlements?.[0]
              ? true
              : false,
        };

        const token = await (authen?.currentUser as any).getIdToken(true);

        const result = await deleteAccountApi(
          userInfo,
          token,
          environment?.apiUrl
        );
        setIsModalVisible(false);

        if (result == 'Error') {
          setIsQuestionModalVisible(true);
          setApiErrorMessage(
            'We’re currently experiencing some issues. Please try again later.'
          );
          setIsModalVisible(false);
        } else if (!result?.error_message) {
          localStorage.removeItem('userData');
          const questionInfo = {
            uid: '',
            mode: '',
            level: '',
            filter_type: '',
            filter_value: '',
            include_incorrect: '',
          };
          await dispatch(setFilter(questionInfo));
          await dispatch(setUserProfile(''));
          await dispatch(setBadge(null));
          await dispatch(setLevelImage([]));
          await dispatch(setAvatar([]));
          await dispatch(setProduct([]));
          navigate('/login');
        } else {
          setApiErrorMessage(result?.error_message);
          setIsQuestionModalVisible(true);
          setIsModalVisible(false);
        }
      } catch (error) {
        RemoteErrorLog(error, 'Navbar.tsx');
      }
    } else {
      window.alert('User not found.');
    }
  };
  const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSubMenuToggle = () => {
    setSubMenuOpen(!subMenuOpen);
  };
  const hideModal = () => {
    setIsModalVisible(false);
  };
  const hideSubscriptionDeleteModal = () => {
    setIsSubscriptionDeleteModalVisible(false);
  };

  const hideNoQuestionModal = () => {
    setIsQuestionModalVisible(false);
  };

  const handleAuthMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setAuthMenuAnchor(event.currentTarget);
  };

  const handleAuthMenuClose = () => {
    setAuthMenuAnchor(null);
  };

  const handleHomeNavigation = () => {
    if (!user || user.isAnonymous) {
      navigate('/');
    } else {
      navigate('/home');
    }
  };


  return (
    <>
      <main>
        <AppBar
          position="fixed"
          color="default"
          sx={{ background: '#fff' }}
          className="navbar-new-section"
        >
          <Container
            sx={{
              maxWidth: { xs: '100%', sm: '100%', md: '1460px' },
            }}
          >
            <Toolbar disableGutters>
              <Link to="/" className="logo-company">
                <img src={Logoapp} alt="Logo" style={{ marginRight: 16 }} />
              </Link>
              <Box
                sx={{ 
                  flexGrow: 1, 
                  display: { xs: 'none', md: 'flex' },
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                className="navbar-content">
                  <>
                    <GlowingButton
                      onClick={handleHomeNavigation}
                      active={currentPage == 'home'}
                      sx={{ my: 2 }}
                    >
                      Home
                    </GlowingButton>
                    {user && !user.isAnonymous ? (
                      <>
                        <GlowingButton
                          component={Link}
                          to="/myProgress"
                          active={currentPage == 'myprogress'}
                          sx={{ my: 2 }}
                        >
                          My Progress
                        </GlowingButton>
                        <GlowingButton
                          component={Link}
                          to="/profile"
                          active={currentPage == 'myprofile'}
                          sx={{ my: 2 }}
                        >
                          My Profile
                        </GlowingButton>
                        <GlowingButton
                          component={Link}
                          to="/subscription"
                          active={currentPage == 'subscription'}
                          sx={{ my: 2 }}
                        >
                          My Membership
                        </GlowingButton>
                      </>
                    ) : (
                      <>
                        <GlowingButton
                          component={Link}
                          to="/about-us"
                          active={currentPage == 'aboutus'}
                          sx={{ my: 2 }}
                        >
                          About us
                        </GlowingButton>
                        <GlowingButton
                          component={Link}
                          to="/pricing"
                          active={currentPage == 'pricing'}
                          sx={{ my: 2 }}
                        >
                          Pricing
                        </GlowingButton>
                        {/* Resources — only show for non-logged users */}
                        <GlowingButton
                          component={Link}
                          to="/resources"
                          active={currentPage == 'resources'}
                          sx={{ my: 2 }}
                        >
                          Resources
                        </GlowingButton>
                      </>
                    )}


                  </>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography
                    variant="h6"
                    noWrap
                    sx={{
                      color: '#2A9235',
                      fontSize: {
                        xs: 12,
                        sm: '1.25rem',
                      },
                    }}
                  >
                    {currentPage == 'login' ||
                      currentPage == 'signup' ||
                      userData?.isAnonymous == null
                      ? ''
                      : userData?.isAnonymous
                        ? 'Guest'
                        : formatName(profile?.user?.full_name)}
                  </Typography>
                  <AnimatedAvatar
                    src={
                      userData?.isAnonymous == null || user?.isAnonymous == null
                        ? usericon
                        : userData?.isAnonymous
                          ? usericon
                          : profile?.user?.img_uri_https
                    }
                    alt="User Icon"
                  />
                </Box>

                {(!user || user.isAnonymous) ? (
                  <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
                    <GlowingButton
                      component={Link}
                      to="/login"
                      active={currentPage == 'login' || currentPage == 'signup' || currentPage == 'myaccount'}
                      sx={{ 
                        fontSize: '18px',
                        fontWeight: 500,
                        padding: '8px 16px',
                      }}
                    >
                      Log in
                    </GlowingButton>
                    <PremiumButton
                      variant="contained"
                      size="medium"
                      endIcon={<ArrowForward sx={{ ml: 1, fontSize: { xs: '1rem', md: '1.1rem' } }} />}
                      component={Link}
                      to="/signup"
                      sx={{
                        fontSize: { xs: '0.95rem', sm: '1rem', md: '1rem' },
                        py: { xs: 1.25, sm: 1.5, md: 1.75 },
                        px: { xs: 3, sm: 4, md: 4 },
                        minWidth: { xs: 'auto', sm: '200px', md: 160 },
                        width: { xs: '100%', md: 'auto', lg: 'auto' },
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 'none',
                      }}
                    >
                      Try it for free
                    </PremiumButton>
                  </Box>
                ) : (
                  <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                    <GlowingButton
                      onClick={handleLogoutClick}
                      sx={{ 
                        fontSize: '18px',
                        padding: '6px 16px'
                      }}
                    >
                      Logout
                    </GlowingButton>
                  </Box>
                )}

                <IconButton
                  size="large"
                  edge="end"
                  color="inherit"
                  aria-label="menu"
                  onClick={handleSubMenuToggle}
                  sx={{ display: { xs: 'flex', md: 'none' } }}
                >
                  <SvgIcon sx={{ marginTop: 2 }}>
                    <Hamburger />
                  </SvgIcon>
                </IconButton>
                {user && !user.isAnonymous && (
                  <IconButton
                    size="large"
                    edge="end"
                    color="inherit"
                    aria-label="more"
                    onClick={handleSubMenuToggle}
                    sx={{ display: { xs: 'none', md: 'flex' } }}
                  >
                    <SvgIcon sx={{ marginTop: 2 }}>
                      <Hamburger />
                    </SvgIcon>
                  </IconButton>
                )}
              </Box>
            </Toolbar>
          </Container>
        </AppBar>

        {subMenuOpen && (
          <Box
            sx={{
              position: 'fixed',
              top: '64px',
              width: '100%',
              backgroundColor: '#EBEBEB',
              boxShadow: 3,
              zIndex: 1100,
            }}
          >
            <Container>
              <Box className="scroll-navbar">
                <Box className="navbar-top-content">
                  <>
                    <MenuItem
                      onClick={() => {
                        handleHomeNavigation();
                        handleMenuClose();
                      }}
                      style={{ color: currentPage == 'home' ? 'green' : '' }}
                    >
                      Home
                    </MenuItem>
                    {user && !user.isAnonymous && (
                      <>
                        <MenuItem
                          component={Link}
                          to="/myProgress"
                          onClick={handleMenuClose}
                          style={{ color: currentPage == 'myprogress' ? 'green' : '' }}
                        >
                          My progress
                        </MenuItem>
                        <MenuItem
                          component={Link}
                          to="/profile"
                          onClick={handleMenuClose}
                          style={{ color: currentPage == 'myprofile' ? 'green' : '' }}
                        >
                          My profile
                        </MenuItem>
                        <MenuItem
                          component={Link}
                          to="/subscription"
                          onClick={handleMenuClose}
                          style={{ color: currentPage == 'subscription' ? 'green' : '' }}
                        >
                          My Membership
                        </MenuItem>
                      </>
                    )}
                    {(!user || user.isAnonymous) && (
                      <>
                        <MenuItem
                          component={Link}
                          to="/about-us"
                          onClick={handleMenuClose}
                          style={{ color: currentPage == 'aboutus' ? 'green' : '' }}
                        >
                          About us
                        </MenuItem>
                        <MenuItem
                          component={Link}
                          to="/pricing"
                          onClick={handleMenuClose}
                          style={{ color: currentPage == 'pricing' ? 'green' : '' }}
                        >
                          Pricing
                        </MenuItem>
                        <MenuItem
                          component={Link}
                          to="/resources"
                          onClick={handleSubMenuToggle}
                          style={{ color: currentPage == 'resources' ? 'green' : '' }}
                        >
                          Resources
                        </MenuItem>
                        <MenuItem
                          component={Link}
                          to="/signup"
                          onClick={handleMenuClose}
                          style={{ color: currentPage == 'pricing' ? 'green' : '' }}
                        >
                          Sign up
                        </MenuItem>
                      </>
                    )}
                  </>

                  {userData?.isAnonymous == true ||
                    userData?.isAnonymous == null ? (
                    <MenuItem
                      component={Link}
                      to="/login"
                      style={{ color: currentPage == 'login' ? 'green' : '' }}
                    >
                      Login
                    </MenuItem>
                    
                  ) : (
                    <>
                      <MenuItem
                        component={Link}
                        to=""
                        onClick={handleLogoutClick}
                      >
                        Logout
                      </MenuItem>
                    </>
                  )}

                </Box>

                <List
                  className="navbar-upper-content-list"
                  sx={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 0,
                    whiteSpace: 'nowrap',
                    color: '#5E5E5E',
                    '& .MuiListItem-root': {
                      ...(isMobile ? {} : {
                        padding: '8px 16px',
                        marginRight: '16px',
                        '&:last-child': {
                          marginRight: 0,
                        }
                      }),
                    },
                    ...(isMobile ? {} : {
                      gap: '16px',
                    }),
                  }}
                >
                <ListItem
                    button
                    component={Link}
                    to="/about-us"
                    onClick={handleSubMenuToggle}
                    style={{
                      color: currentPage == 'aboutus' ? 'green' : '',
                    }}
                  >
                    <ListItemText primary="About us" />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to="/privacy-policy"
                    onClick={handleSubMenuToggle}
                    style={{
                      color: currentPage == 'privacypolicy' ? 'green' : '',
                    }}
                  >
                    <ListItemText primary="Privacy Policy" />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to="/terms-of-service"
                    onClick={handleSubMenuToggle}
                    style={{
                      color: currentPage == 'termsofservice' ? 'green' : '',
                    }}
                  >
                    <ListItemText primary="Terms & Conditions" />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to="/change-password"
                    style={{
                      color: currentPage == 'changePassword' ? 'green' : '',
                    }}
                    onClick={handleSubMenuToggle}
                  >
                    <ListItemText primary="Change password" />
                  </ListItem>
                  {user && !user.isAnonymous && (
                    <ListItem
                      button
                      component={Link}
                      to=""
                      onClick={() => {
                        handleDeleteClick();
                        handleSubMenuToggle();
                      }}
                    >
                      <ListItemText primary="Delete account" />
                    </ListItem>
                  )}
                  {user && !user.isAnonymous && (
                    <ListItem
                      button
                      component={Link}
                      to="/contact-us"
                      style={{
                        color: currentPage == 'contactus' ? 'green' : '',
                      }}
                      onClick={handleSubMenuToggle}
                    >
                      <ListItemText
                        primary="Contact us"
                        className="List-details"
                      />
                    </ListItem>
                  )}
                  <ListItem sx={{}}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isSoundEnabled}
                          onChange={(e) => {
                            const newState = e.target.checked;
                            setIsSoundEnabled(newState);
                            localStorage.setItem('GlobalSoundsControl', newState ? 'ON' : 'OFF');
                          }}
                          color="success"
                        />
                      }
                      label={
                        <Typography variant="body1">
                          Global Sounds
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>
              </Box>
            </Container>
          </Box>
        )}

        <ConfirmModal
          open={open}
          onClose={handleClose}
          onConfirm={signOutUser}
        />

        <CustomDeleteModal
          isModalVisible={isModalVisible}
          onPressbutton1={hideModal}
          onPressbutton2={handleDeleteAccount}
          buttonText1="No"
          buttonText2="Yes"
          modalTitle="Delete Account"
          text="This will delete all your data, including learning history. Once you delete your account, we cannot recover it. It will be gone forever."
          text2="Are you sure you want to continue?"
        />
        <CustomDeleteModal
          isModalVisible={isSubscriptionDeleteModalVisible}
          onPressbutton1={hideSubscriptionDeleteModal}
          onPressbutton2={deleteAccount}
          buttonText1="No"
          buttonText2="Yes"
          modalTitle="Delete Account"
          text="If you proceed with the deletion, we will cancel your purchased ad-free membership, and reactivation won’t be possible. Additionally, any remaining paid funds, valid until the end of the billing cycle, will be forfeited."
          text2="Are you sure you want to continue?"
        />
        <CustomNoResponseModal
          isModalVisible={isQuestionModalVisible}
          onPress={hideNoQuestionModal}
          buttonText="OK"
          modalTitle="Oops!"
          text={apiErrorMessage}
        />
      </main>
    </>
  );
}
